function getSortTitle(nextSortingOrder) {
    switch (nextSortingOrder) {
        case "asc":
            return "Sort ascending";
        case "desc":
            return "Sort descending";
        default:
            return "Clear sort";
    }
}

export { getSortTitle };
//# sourceMappingURL=getSortTitle.js.map
